import React, { Component } from 'react'
import moment from 'moment';
import Input from './shared/Input';
import Button from './shared/Button';
import { connect } from "react-redux";
import Loader from './shared/Loader'
import profileApi from '../api/auth'
import { profileUpdateStages, profileClearStagesResult } from '../store/profile/actions'
import { profileFetchIfNeeded, profileInvalidate } from './../store/profile/actions';
import { SHORT_SUBJECT_TYPE } from './../constants/subjectTypes';
import { get } from 'lodash'
import ReactPhoneInput from './shared/PhoneInput';
import { isVerificateCode } from "../utils/validate";
import Timer from './LanguageTest/Timer';
import { trackValues } from './../tracker';
import { trackSiteId } from './../config';

import baseStyles from 'custom/base.styl';
import classnames from "classnames";

class PhoneVerification extends Component {
  constructor(props) {
    super(props)

    this.onPhoneChange = this.onPhoneChange.bind(this)
    this._handleOnChange = this._handleOnChange.bind(this)
    this._handleSubmit = this._handleSubmit.bind(this)
    this._requestCode = this._requestCode.bind(this)
    this._verifyCode = this._verifyCode.bind(this)
    this._handleOnClickSendNewCode = this._handleOnClickSendNewCode.bind(this)
    this.onChangeNumber = this.onChangeNumber.bind(this)
    this.timeout = this.timeout.bind(this)

    this.state = {
      phone: '',
      code: '',
      codeReceived: false,
      fieldError: {},
      errors: [],
      codeSending: false,
      isChangePhone: false,
      endTime: localStorage.getItem('endTimeSms') || null,
    }
  }

  componentDidMount() {
    const { profilePhone, verificated, profileUpdateStages } = this.props;

    if (verificated) {
      this.onTrackData();
      profileUpdateStages({});
      return;
    }

    this.setState({
      phone: profilePhone,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profilePhone !== this.props.profilePhone) {
      this.setState({
        phone: this.props.profilePhone
      });
    }
  }

  onTrackData() {
    const { version, userId, subjectType } = this.props;
    const dataTracker = { userId, version, site_id: trackSiteId, preferredSubject: SHORT_SUBJECT_TYPE[subjectType], is_optional: false }

    trackValues('phone_verification_2', true, {
      context: dataTracker,
    });
  }

  timeout() {
    localStorage.removeItem('endTimeSms');
    this.setState({ endTime: null });
  }

  hasPhone() {
    const { phone } = this.state;
    return ((phone || '').trim() || '').length > 6;
  }

  onPhoneChange(phone) {
    this.setState({ phone });
  }

  _handleOnChange(e) {
    const { name, value } = e.target;

    if (name === 'code' && !isVerificateCode(value)) {
      return null;
    }
      this.setState({
        [name]: value.trim()
      });
  }

  _handleSubmit(e) {
    e.preventDefault();
  }

  _verifyCode() {
    const { code } = this.state;

    const data = {
      code,
    };
    this.onTrackData();
    this.props.profileUpdateStages(data)
  }

  _requestCode() {
    const { phone } = this.state
    const data = { phone: (phone || '').replace(/[^+0-9]/g, '') }

    const endTime = moment().add(2, 'minutes').format();
    localStorage.setItem('endTimeSms', endTime);

    this.setState({
      codeSending: true,
      isChangePhone: false,
      endTime,
    })

    profileApi.requestCode(data).then(resp => {
      this.setState({
        codeReceived: true,
        errors: [],
        codeSending: false,
      })
    }).catch(error => {
      this.setState({
        codeSending: false,
      });

      this.setState({
        errors: get(error, 'errors', [])
      })
    });
  }

  _handleOnClickSendNewCode(e) {
    e.preventDefault()
    this.props.profileClearStagesResult()
    this._requestCode()
  }

  onChangeNumber(e) {
    e.preventDefault()

    this.setState({
      isChangePhone: true,
      code: '',
    });
  }

  render() {
    const { isFetching, stagesResult, countryCode, verificated } = this.props;
    const { phone, codeReceived, code, errors, codeSending, isChangePhone, endTime } = this.state;

    if (isFetching || verificated) {
      return <Loader absolute />
    }

    return [
      <div className={baseStyles.content} key='phone-verfication-intro'>
        <h2 className={classnames(baseStyles.succeess_title, baseStyles.text_large, baseStyles.mb_10, baseStyles.centered)}>Congratulations!</h2>
        <p className={baseStyles.subtitle}>
          You’ve completed the last stage of our recruiting process.  <br/>
          After you verify your phone number our Recruiting Managers <br/>will start checking your application.
        </p>
      </div>,

      <div className={baseStyles.form_styles} key='phone-verfication-form'>
        <form onSubmit={this._handleSubmit} method="post">
          {/* {!codeReceived && */}
          <div className={baseStyles.form_field}>
            <h4 className={baseStyles.form_label}>Phone number</h4>
            <div className={baseStyles.field_wrap}>
              <ReactPhoneInput
                onChange={this.onPhoneChange}
                value={phone}
                defaultCountry={countryCode}
                placeholder="Enter phone number"
                inputClass={baseStyles.phone_field}
                disableAreaCodes={true}
                disabled={(codeSending || codeReceived) && !isChangePhone}
              />
              <Button
                className={classnames(baseStyles.btn_verify, baseStyles.btn_loading)}
                success
                type="button"
                onClick={this._requestCode}
                disabled={(codeSending || codeReceived || endTime) && !isChangePhone}
              >
                {codeSending &&
                  <i className={baseStyles.icon_spin}>&#xe838;</i>
                }
                {!codeSending &&
                  <span>Verify</span>
                }
              </Button>
            </div>
          </div>
          {/* } */}

          {/* {codeReceived && */}
          <div className={baseStyles.form_field}>
            <h4 className={baseStyles.form_label}>Enter code from SMS</h4>
            <div className={baseStyles.field_wrap}>
              <Input type="text" placeholder="Enter code"
                value={code}
                name="code"
                className={classnames({ [baseStyles.error]: !stagesResult })}
                block onChange={this._handleOnChange} />
              <Button className={baseStyles.btn_verify} success disabled={codeSending || !codeReceived || !code} type="button" onClick={this._verifyCode}>Submit</Button>
            </div>
            {!stagesResult && <h4 className={baseStyles.form_label_error}>Incorrect code</h4>}
          </div>
          {/* } */}

          {/* {!stagesResult && */}
          {/* <div className={classnames(baseStyles.space_bottom, baseStyles.form_common_desc)}>
            <span>Didn’t get the code?</span>
            <a href="" onClick={this._handleOnClickSendNewCode}>Resend</a>
            <span>&nbsp;or</span>
            <a href="" onClick={this.onChangeNumber}>Change number</a>
          </div> */}
          {/* } */}
          {!endTime &&
            <div className={classnames(baseStyles.space_bottom, baseStyles.form_common_desc)}>
              <span>Didn’t get the code?</span>
              <a href="" onClick={(e) => this.onChangeNumber(e)}>Change number</a>
              <span>&nbsp;or</span>
              <a href="" onClick={this._handleOnClickSendNewCode}>Resend</a>
            </div>
          }

          {endTime &&
            <div className={classnames(baseStyles.space_bottom, baseStyles.form_common_desc)}>
              Didn’t get the code? <br /> Change number or Resend in <Timer endTime={endTime} submitTest={() => this.timeout()} /> min
              </div>
          }

          {errors.map((item, key) => <div key={`registration-error-${key}`}
            className={classnames(baseStyles.text_danger, baseStyles.space_bottom)}>{item}</div>)}
        </form>
      </div>
    ]
  }
}

const mapStateToProps = state => {
  const profile = state.profile;
  const profilePhone = get(profile.data, 'user.profile.phone');
  const first = get(profile.data, 'user.profile.first_name') || '';
  const last = get(profile.data, 'user.profile.last_name') || '';
  const countryCode = get(profile.data, 'user.profile.geoip_country_code');
  const verificated = get(profile.data, 'user.profile.phone_verificated');
  const subjectType = get(profile.data, 'user.profile.subject_type');
  const userId = get(state.profile.data, 'user.id');
  const version = get(state.profile.data, 'user.scenario_version');

  return {
    profilePhone,
    profileName: `${first} ${last}`.trim(),
    countryCode: (countryCode || '').toLowerCase(),
    isFetching: profile.isFetching,
    stagesResult: profile.stagesResult,
    verificated,
    subjectType,
    userId,
    version,
  };
};

const mapDispatchToprops = dispatch => ({
  load: () => {
    dispatch(profileInvalidate());
    dispatch(profileFetchIfNeeded());
  },
  profileUpdateStages: (data) => (dispatch(profileUpdateStages(data))),
  profileClearStagesResult: () => (dispatch(profileClearStagesResult())),
});

export default connect(mapStateToProps, mapDispatchToprops)(PhoneVerification);



// WEBPACK FOOTER //
// ./src/components/PagePhoneVerification2.js